import { Component } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { MenuItem } from 'primeng/api';
import { EnvironmentService } from '../utility/environment.service';
import { UserroleService } from '../utility/userrole.service';
import { AuthenticationService } from '../core/services/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  public userName: string;
  public userRole: string;

  public userObject: any;
  public token: any;
  public refreshToken: any;

  userRoles: string[];

  items: MenuItem[];

  constructor(
    private authenticationService: AuthenticationService,
    private keycloak: KeycloakService,
    private environmentser: EnvironmentService,
    private userroleser: UserroleService
  ) {}

  async ngOnInit(): Promise<void> {

    this.authenticationService.getUserRolesForMenubar().subscribe((newRole)=>{
      this.userRole = this.userroleser.roleTypeForHeader(newRole);
    });
    this.userName = this.authenticationService.getCurrentUser().realname;
  }

  logout() {
    this.keycloak.logout(this.environmentser.getLandingURL());
  }

  async update() {
    //TODO: Move to authenticationService
    await this.keycloak.updateToken(-1).then(async () => {
      this.token = await this.keycloak.getToken();
    });
    this.refreshToken = this.keycloak.getKeycloakInstance().refreshToken;
  }
}
